import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-x-0 bottom-4 z-50 mx-auto max-w-md"
}
const _hoisted_3 = { class: "flex items-center justify-between gap-x-4 bg-gray-900 px-4 py-3 rounded-lg shadow-lg" }
const _hoisted_4 = { class: "text-sm leading-6 text-white" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "bg-gradient-to-b from-white to-gray-50 py-12 px-4 sm:px-6 lg:py-16" }
const _hoisted_8 = { class: "max-w-3xl mx-auto" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl" }
const _hoisted_11 = { class: "mt-3 max-w-2xl text-center mx-auto text-xl text-gray-500 sm:mt-4" }
const _hoisted_12 = { class: "mt-8 max-w-md mx-auto" }
const _hoisted_13 = { class: "bg-white rounded-xl shadow-sm p-4" }
const _hoisted_14 = { class: "flex gap-3" }
const _hoisted_15 = { class: "flex-grow" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.error != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.pageStr + '.fehler')), 1),
              _cache[4] || (_cache[4] = _createElementVNode("svg", {
                viewBox: "0 0 2 2",
                class: "mx-2 inline h-0.5 w-0.5 fill-current",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "1",
                  cy: "1",
                  r: "1"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.pageStr + '.session_id_not_found')), 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = 0)),
              class: "-m-3 flex-none p-3 focus-visible:outline-offset-[-4px]"
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.pageStr + '.dismiss')), 1),
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "h-5 w-5 text-white",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", { d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" })
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.pageStr + '.no_active_configurations')), 1),
          _createElementVNode("p", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.pageStr + '.you_have_no_active_configurations')) + " ", 1),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.pageStr + '.to_start_a_new_one_select')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "item_number",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemNumber) = $event)),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.createSession(_ctx.itemNumber)), ["enter"])),
                  class: "block w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition",
                  placeholder: _ctx.$t(_ctx.pageStr + '.enter_item_number'),
                  "aria-describedby": "item-number-helper"
                }, null, 40, _hoisted_16), [
                  [_vModelText, _ctx.itemNumber]
                ])
              ]),
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createSession(_ctx.itemNumber))),
                  class: "bg-white inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    class: "-ml-2 mr-1 h-5 w-5 text-gray-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                      "clip-rule": "evenodd"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.pageStr + '.open')), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}